import React, { useState, useEffect, useRef, useContext } from "react";
import { Alert } from "reactstrap";
import Pagination from '../../components/pagination/pagination';
import SubUsersTable from "../../components/subUsersTable";
import SubUsersTableModal from "../../components/subUsersTableModal";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useFetch } from "../../utils/fetchHook";
import { useTranslation } from "react-i18next";
import { StateContext } from "../../utils/context";

const SubUsers = props => {
  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);
  const { t } = useTranslation();

  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [updateBody, setUpdateBody] = useState(false);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [forceUpdate, setForce] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'id', sort: 'id'});


  const [apiData, error, loading] = useFetch("GET",`sub-users/?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}`,token,false,forceUpdate);
  const [tableData, setTableData] = useState([]);

  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);
 
  const [lastAction, setLastAction] = useState("updated");

  useEffect(() => {
    setTableData(apiData.results);
    setDataCount(apiData.count);
  }, [apiData]);


  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const handlerValues = { setSuccess, setError, forceUpdate, setForce };

  return (
    <>
      {
        !currentUser.is_premium_user && (
          <Alert color="danger">
            {t("subUsers.view.message.premiumUsersOnly")}
          </Alert>        
        )
      }

      {
        loading ? (
          <TableHelper loading />
        ) : error ? (
          <TableHelper error />
        ) :  (
        <div>
          <ViewLayout title={t("subUsers.view.title")}>
            <SubUsersTable
              setToggleModal={setToggleModal}
              setDataModal={setDataModal}
              setUpdateBody={setUpdateBody}
              setLastAction={setLastAction}
              forceUpdate={forceUpdate}
              data={tableData}
              defaultSorted={defaultSorted}
              searchQuery={{setQuery, query, ordering, setOrdering}}
            />
          </ViewLayout>
          <Pagination pagination={paginationProps}/>
        </div>
      ) }
        
      
      {dataModal && (
        <SubUsersTableModal
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          values={handlerValues}
          title={
            dataModal.is_active ? t("subUsers.view.modal.deactivateSubuser.header") : t("subUsers.view.modal.activateSubuser.header")
          }
          body={
            dataModal.is_active? t("subUsers.view.modal.deactivateSubuser.body", {username: dataModal.username})
            : t("subUsers.view.modal.activateSubuser.body", {username: dataModal.username})
          }
          apiURL={`sub-users/${dataModal.id}`}
          bodyID={dataModal.id}
          activateUser={dataModal.is_active? false: true}
          updateBody={updateBody}
        />
      )}
      {
        success && 
        <Alert color="success">
          {lastAction === "activated" ? t("subUsers.view.message.successActivated") :
          lastAction === "de-activated" ? t("subUsers.view.message.successDeactivated") :
          t("subUsers.view.message.successUpdated")}
        </Alert>
      }
      {errorPut && (
        <Alert color="danger">
          {t("subUsers.view.message.error")}
        </Alert>
      )}
    </>
  );
};

export default SubUsers;
